import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { formatPepExposure } from "./utils";

type Props = {
  pepCategory: number | null | undefined;
};

export const PepExposureValue = ({ pepCategory }: Props) => {
  const label = formatPepExposure(pepCategory);
  const showIcon = pepCategory != null;

  return (
    <Flex
      alignItems="center"
      gap={4}
      style={{ height: "100%" }}
      data-testid="pep-exposure-value"
    >
      {showIcon && (
        <Icon
          type="exclamation-triangle"
          variant="outline"
          color={Colors.Warning600}
          data-testid="pep-exposure-icon"
        />
      )}
      <Text
        data-testid="pep-exposure-label"
        style={showIcon ? { color: Colors.Warning600 } : undefined}
      >
        {label}
      </Text>
    </Flex>
  );
};
